export default function UnsubscribePage() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Has sido dado de baja</h1>
      <p>Ya no recibirás más contenido de ZEDRO.</p>
    </div>
  );
}